import { render, staticRenderFns } from "./NetdocBldg.vue?vue&type=template&id=c0db51e6&scoped=true"
import script from "./NetdocBldg.vue?vue&type=script&lang=js"
export * from "./NetdocBldg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0db51e6",
  null
  
)

export default component.exports